import { AppServicesType } from "@enums/AppServicesType";
import apiClient, { getUserId } from "./apiClient";

export const deleteAssociation = async (service: AppServicesType, id: number) => {
  const userId = getUserId();
  const url = `/api/v1/move/servicesAssociations/${service}/${id}?userId=${userId}`;
  const response = await apiClient.delete(url);
  return response.data;
};
